var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 207 71",
    width: 102,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u63FD\u8FB0logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 71h207v-71h-207z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffa515 } \n\t\t.s1 { fill: #feffff } \n\t\t.s2 { fill: #14161e } \n\t\t.s3 { fill: #000000 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-24\\u5907\\u4EFD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    className: "s0",
    d: "m71 36l-0.1 2.7q-0.2 2.4-0.7 4.7c-3.1 13.9-14.6 24.8-29.2 27.1q-1.6 0.3-3.2 0.4-1.4 0.1-2.8 0.1v-35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    fillRule: "evenodd",
    className: "s1",
    d: "m59 35v0.1c0 12.6-10.3 22.9-22.9 22.9h-0.1v5h0.1c15.4 0 27.9-12.5 27.9-27.9v-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    fillRule: "evenodd",
    className: "s1",
    d: "m49 35v0.1c0 7.1-5.8 12.9-12.9 12.9h-0.1v5h0.1c9.9 0 17.9-8 17.9-17.9v-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    fillRule: "evenodd",
    className: "s1",
    d: "m38.9 35v0.1c0 1.6-1.2 2.8-2.8 2.8h-0.1v5.1h0.1c4.4 0 7.9-3.5 7.9-7.9v-0.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Fill-9",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "s0",
    d: "m0 36h36v-36h-36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Fill-11",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "s0",
    d: "m0 71h36v-36h-36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Fill-12",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "s0",
    d: "m35 36h36v-36h-36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Fill-13",
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "s1",
    d: "m0 36h6v-36h-6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Fill-14",
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    className: "s1",
    d: "m23 36h6v-36h-6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Fill-15",
    clipPath: "url(#cp6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "s1",
    d: "m12 36h6v-36h-6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Fill-16",
    clipPath: "url(#cp7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    className: "s1",
    d: "m46 10h21v-5h-21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Fill-17",
    clipPath: "url(#cp8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "s1",
    d: "m46 31h21v-5h-21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Fill-18",
    clipPath: "url(#cp9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    className: "s1",
    d: "m41 26h5v-16h-5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Fill-19",
    clipPath: "url(#cp10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "s1",
    d: "m31 66h-26v-26h5.4v21h20.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: \\u7F16\\u7EC4-23",
    clipPath: "url(#cp11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    fillRule: "evenodd",
    className: "s2",
    d: "m114.6 27.8c1.8 0 3.2-1.4 3.2-3.1v-11.6c0-1.7-1.4-3.1-3.2-3.1-1.7 0-3.2 1.4-3.2 3.1v11.6c0 1.7 1.5 3.1 3.2 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    fillRule: "evenodd",
    className: "s2",
    d: "m106 27.9c1.8 0 3.2-1.4 3.2-3.1v-11.6c0-1.7-1.4-3.1-3.2-3.1-1.7 0-3.2 1.4-3.2 3.1v11.6c0 1.7 1.5 3.1 3.2 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    fillRule: "evenodd",
    className: "s2",
    d: "m135.5 29.2l-29.6 0.2c-1.9 0-3.5 1.5-3.6 3.3h-0.1v19.1c0 1.9 1.7 3.5 3.7 3.5h0.2c1.9-0.1 3.4-1.7 3.4-3.5v-15.4l22.5-0.2v15.6c0 1.9 1.6 3.5 3.6 3.5 2 0 3.6-1.6 3.6-3.5v-19.1c0-2-1.7-3.5-3.7-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    fillRule: "evenodd",
    className: "s2",
    d: "m96 34.4v-4.2c1.8-0.3 3.2-1.7 3.2-3.5 0-1.8-1.4-3.3-3.2-3.5v-9.6c0-1.9-1.6-3.5-3.6-3.5h-0.3c-1.9 0.1-3.4 1.6-3.4 3.5v9.6h-4.1c-2 0-3.6 1.6-3.6 3.5v0.2c0.1 1.9 1.7 3.3 3.6 3.3h4.1v12.4l-5.1 6.2c-1.1 1.3-0.8 3.2 0.5 4.3 1.4 1 3.4 0.8 4.5-0.5l0.1-0.2v7.2h-0.7c-2 0-3.7 1.6-3.7 3.5 0 2 1.7 3.5 3.7 3.5h4.4 0.2c1.9-0.1 3.4-1.6 3.4-3.5v-19.4l3.7-4.5c1.1-1.4 0.9-3.3-0.5-4.3-0.9-0.8-2.2-0.9-3.2-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    fillRule: "evenodd",
    className: "s2",
    d: "m135.5 59.6h-0.4c-4.3 0-8.3-2-10.7-5.4v-10.5c0-1.9-1.6-3.4-3.6-3.4-2 0-3.7 1.5-3.7 3.4v10.5c-2.4 3.4-6.4 5.4-10.7 5.4h-0.5c-2 0-3.6 1.5-3.6 3.5 0 1.9 1.6 3.5 3.6 3.5h0.5c5.5 0 10.6-2.1 14.4-5.7 3.7 3.6 8.9 5.7 14.3 5.7h0.4c2 0 3.6-1.6 3.6-3.5 0-2-1.6-3.5-3.6-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    fillRule: "evenodd",
    className: "s2",
    d: "m136.8 10.1h-12.2q-0.3 0-0.5 0h-0.2c-1.7 0.1-3 1.4-3 3.1v11.6c0 1.7 1.5 3.1 3.2 3.1h0.2c1.7-0.1 3-1.5 3-3.1v-4.4l4.9 4.9c1.2 1.2 3.2 1.3 4.5 0.1 1.2-1.2 1.3-3.1 0.1-4.3l-4.9-4.9h4.9c1.7 0 3.2-1.4 3.2-3.1 0-1.7-1.5-3-3.2-3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    fillRule: "evenodd",
    className: "s3",
    d: "m152.5 65.6q-1 2.5-2.3 3.1-1.3 0.6-3.1-0.1-1.7-0.7-2.3-2.1-0.5-1.3 0.6-3.8 1.1-2.5 1.9-4.6 0.7-2.2 1.2-4.8 0.4-2.7 0.6-6.4 0.2-3.7 0.2-9.3v-19.4q0-2.5 0.3-4.1 0.4-1.5 1.3-2.5 0.9-0.9 2.3-1.2 1.5-0.4 3.7-0.4h44q2.2 0 2.9 0.8 0.8 0.8 0.8 2.7 0 2-0.8 2.8-0.7 0.8-2.9 0.8h-43.2q-0.5 0-0.6 0.2-0.2 0.2-0.2 0.9v15.2h45.3q2.2 0 2.9 0.9 0.7 0.9 0.7 2.6 0 1.7-0.7 2.6-0.7 1-2.9 1h-19.3q0.7 2.1 1.6 4.1 0.9 2.1 2 3.8 3.4-1.1 6.2-2.4 2.7-1.3 5.4-3.1 2-1.2 3.3-1.4 1.4-0.1 2.7 1.8 1.1 1.6 0.6 2.8-0.5 1.3-2.6 2.7-4.9 3-11 5 2.2 2.2 5 4.1 2.7 1.8 5.8 2.9 2.6 0.9 3.6 2.3 1 1.3 0 3.5-0.9 2-2.5 2-1.6 0.1-3.7-0.7-9.1-3.9-15-10.6-5.8-6.7-8.9-16.8h-7.3v17.9q0 1.6 1.2 1.3 1.3-0.4 2.2-0.7 0.9-0.3 1.9-0.6 0.9-0.3 2-0.7 1.1-0.3 2.7-0.9 1.2-0.3 2.1-0.5 0.9-0.2 1.6-0.1 0.7 0.1 1.2 0.5 0.5 0.5 1 1.5 0.7 1.7 0 3-0.6 1.3-3.1 2.4-1.7 0.7-3.2 1.3-1.5 0.7-3.1 1.2-1.6 0.5-3.5 1.1-1.9 0.5-4.5 1-1.6 0.3-2.7 0.2-1.1-0.1-1.8-0.8-0.7-0.7-1-2.2-0.4-1.4-0.4-3.9v-21h-3.8q-0.1 5.4-0.4 9-0.3 3.6-0.8 6.3-0.6 2.6-1.4 4.9-0.8 2.2-1.8 4.9zm48.2-40.3q0 1.7-0.7 2.6-0.8 0.9-2.8 0.9h-34.6q-2 0-2.8-0.9-0.7-0.9-0.7-2.6 0-1.8 0.7-2.7 0.8-0.8 2.8-0.8h34.6q2 0 2.8 0.8 0.7 0.9 0.7 2.7z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.svg";
export { ForwardRef as ReactComponent };